<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p>I wish to acknowledge the help I had from Matt Tulloch, who helped put the book together. I would also wish to acknowledge the considerable help my wife, Barbara, gave over the months it took to write this book.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?63167a54